import { render, staticRenderFns } from "./SecretStorageForm.vue?vue&type=template&id=efefd7ac"
import script from "./SecretStorageForm.vue?vue&type=script&lang=js"
export * from "./SecretStorageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports